<template>
  <section class="section">
    <div class="container">
      <h1 class="title">Садржај корпе за куповину</h1>
      <b-steps>
        <b-step-item label="Корпа" icon="account">
          <Korpa />
        </b-step-item>
        <b-step-item label="Провера" icon="account-plus">
          <Provera />
        </b-step-item>
      </b-steps>
    </div>
  </section>
</template>

<script>
import Korpa from '../components/Korpa'
import Provera from '../components/Provera'

export default {
  components: {
    Korpa,
    Provera
  }
}
</script>

<style></style>
